import request from "@/utils/request";
// 个人岗位职称信息查询
export function getjxjyJsGw(params) {
  return request({
    url: "/jxjy/jxjyJsGw/detail",
    method: "get",
    params,
  });
}

// 录入统计概览
export function getXxlrTjgl(params) {
  return request({
    url: "/jxjy/jxjyLrhz/xxlrTjgl",
    method: "get",
    params,
  });
}

// 录入类别
export function queryXxxsBylrlb(params) {
  return request({
    url: "/jxjy/jxjyLrhz/xxlrKslr",
    method: "get",
    params,
  });
}



